import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { IconButton, Tooltip } from "@mui/material";
import BryxIcon from "./BryxIcon/BryxIcon";
import BryxColors from "../types/theme";
const BryxInfoPopup = styled((props) => {
    const cleanProps = { ...props, icon: undefined };
    return (_jsx(Tooltip, { ...cleanProps, disableInteractive: true, arrow: true, placement: "right-end", children: _jsx(IconButton, { disableRipple: true, children: _jsx(BryxIcon, { iconName: "info_rounded", mdIconSize: true }) }) }));
})(({ theme }) => {
    // styles live in the global theme in theme.ts
    const mode = theme.palette.mode;
    return {
        "& *": {
            color: mode == "light" ? BryxColors.brandDark2(mode) : BryxColors.brand4(mode) + " !important",
            fill: mode == "light" ? BryxColors.brandDark2(mode) : BryxColors.brand4(mode) + " !important",
        },
    };
});
export default BryxInfoPopup;
